module.exports = __webpack_public_path__ + "media/svg/medio-cdb9ee8c.svg";